// extracted by mini-css-extract-plugin
export default {"Rating":"Style_Rating__stWzH","ratingIcon":"Style_ratingIcon__7pipj"};